<div class="form-floating">
  <input
    id="typeahead-prevent-manual-entry"
    type="text"
    class="form-control"
    [formControl]="control"
    [ngbTypeahead]="search"
    [inputFormatter]="formatter"
    [resultFormatter]="formatter"
    #instance="ngbTypeahead"
    placement="bottom"
    (selectItem)="onSelected($event)"
    (blur)="onBlur()"
    [ngClass]="{
      'is-invalid': control.errors && !control.pristine,
      'is-valid': formInputOptions.validateSuccess && control.valid && (control.dirty || control.touched),
    }"
    [attr.id]="formInputOptions.name"
    [attr.data-test]="'form-input-' + formInputOptions.name"
    [attr.name]="formInputOptions.name"
    [attr.maxlength]="formInputOptions.maxLength || 64"
    [attr.placeholder]="formInputOptions.placeholder | translate"
    [attr.disabled]="formInputOptions.isDisabled ? '' : null"
    [attr.readonly]="isLoading || formInputOptions.isReadonly ? 'readonly' : null"
    [attr.aria-describedby]="'form-input-desc--' + formInputOptions.name"
    [attr.aria-invalid]="!isValid"
    [attr.aria-label]="(formInputOptions.ariaLabel | translate) || null"
  />
  @if (formInputOptions.labelKey) {
    <label
      [attr.for]="formInputOptions.name"
      class="form-label"
      [ngClass]="formInputOptions.labelCss"
      [translate]="formInputOptions.labelKey"
    ></label>
  }
</div>
